import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose, withHandlers } from "recompose";
import { pairingResults } from "src/modules/pairing/constants";
import { withMessenger } from "src/modules/messenger/Provider";
import { withApp } from "src/components/App/Context";
import { cancelDevicePairing } from "src/modules/pairing/ajax/cloud";

import { getRequest } from "../../duck/selectors";
import handlePairingConfirmation from "./handlePairingConfirmation";
import { resetState } from "../../duck/actions";
import ConfirmationDialog from "./ConfirmationDialog";

const mapStateToProps = (state) => ({
  request: getRequest(state)
});

function mapDispatchToProps(dispatch, { pairingResponder, messenger, app }) {
  const { sendResponseMessage } = pairingResponder;
  return {
    onPairingConfirmed: () =>
      dispatch(
        handlePairingConfirmation({ sendResponseMessage, messenger, app })
      ),
    dispatch
  };
}
const enhance = compose(
  withApp,
  withMessenger,
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onReject:
      ({ dispatch, request, pairingResponder }) =>
      () => {
        cancelDevicePairing(request.requestId);
        pairingResponder.sendResponseMessage({
          result: pairingResults.REJECTED
        });
        dispatch(resetState());
      },
    onDeviceLimitExceed:
      ({ dispatch, request, pairingResponder }) =>
      () => {
        cancelDevicePairing(request.requestId);
        pairingResponder.sendResponseMessage({
          result: pairingResults.EXCEEDED_DEVICE_LIMIT
        });
        dispatch(resetState());
      }
  }),
  withTranslation()
);

export default enhance(ConfirmationDialog);
